module.exports = __webpack_public_path__ + "assets/25b6a7d37f75c65652e7525de1ec919f.mp4";